var exports = {
  "K": "icon__gOq3hF",
  "A": "isExpanded__MsZRax",
};

module.exports = exports;
